import React from 'react';
import PageDetail from './PageDetail';

const CeremonyDetail = (props) => {
  return <PageDetail tag='CEREMONY' url='/ceremony' id={props.match.params.id}/>;
}

export default CeremonyDetail;